// Static curated marketing content for the public landing page.
// Bundled (not DB / API / Pages props) so it is present in the SSR'd HTML.

export interface LanguageRow {
  /** ISO 639 language code used to resolve the flag via LanguageFlag. */
  code: string
  /** Native name, e.g. "Íslenska". */
  native: string
  /** Title-case English label, e.g. "Icelandic", rendered in font-mono. */
  english: string
  /** Destination toward the app (sign-up per research D4). */
  href: string
}

export interface Quote {
  /** The quotation text. */
  text: string
  /** Attribution rendered as <cite>. */
  author: string
}

const SIGN_UP = '/users/sign_up'

// Order preserved from the Mimir.html prototype.
export const LANGUAGES: LanguageRow[] = [
  { code: 'no', native: 'Norsk', english: 'Norwegian', href: SIGN_UP },
  { code: 'is', native: 'Íslenska', english: 'Icelandic', href: SIGN_UP },
  { code: 'de', native: 'Deutsch', english: 'German', href: SIGN_UP },
  { code: 'fr', native: 'Français', english: 'French', href: SIGN_UP },
  { code: 'es', native: 'Español', english: 'Spanish', href: SIGN_UP },
  { code: 'it', native: 'Italiano', english: 'Italian', href: SIGN_UP },
  { code: 'pt', native: 'Português', english: 'Portuguese', href: SIGN_UP },
  { code: 'nl', native: 'Nederlands', english: 'Dutch', href: SIGN_UP },
  { code: 'sv', native: 'Svenska', english: 'Swedish', href: SIGN_UP },
  { code: 'el', native: 'Ελληνικά', english: 'Greek', href: SIGN_UP },
]

export const QUOTES: Quote[] = [
  {
    text: 'The limits of my language mean the limits of my world.',
    author: 'Ludwig Wittgenstein',
  },
  {
    text: 'To have another language is to possess a second soul.',
    author: 'Charlemagne',
  },
  {
    text: 'A different language is a different vision of life.',
    author: 'Federico Fellini',
  },
]

export const PULL_QUOTE: Quote = {
  text: "Learning another language is not only learning different words for the same things, but learning another way to think about things.",
  author: "Flora Lewis · journalist",
}
